import customerAPI from 'api/customer';
import events from 'lib/events';
import IntlWrapper from 'components/layout/intlWrapper';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import {dateTimeFormats} from 'helpers/constants';
import {connectToPOSPermissions, POS_PERMISSIONS} from 'helpers/posPermissions';
import {formatCurrency} from 'helpers/dashboardFormatter';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

let render = (container, params) => {
  console.info('[UI.page.customer] rendering page');
  ReactDOM.render(
    <IntlWrapper>
      <PurchaseDetails customerID={parseInt(params.id)}/>
    </IntlWrapper>, container);
  events.publish('page-change', {page: 'customer'});
};

console.info('[UI.page.customer] register route');
router.rr.add([{path: 'customer/:id/purchase-details', handler: routeUtils.requireAuth(render)}]);

class _PurchaseDetails extends React.Component {
  static propTypes = {
    customerID: PropTypes.number.isRequired,
    intl: intlShape.isRequired,
  };

  state = {
    data: null,
  };

  componentWillMount() {
    customerAPI.getCustomerPurchaseDetails(this.props.customerID)
      .then(res => {
        this.setState({
          data: res,
        });
      });
  }

  exportReport = () => {
    customerAPI.purchaseDetailsExport(this.props.customerID, this.props.intl.locale);
  };

  render() {

    let listItems;

    if(this.state.data) {
      listItems = this.state.data.map(function(item, index) {

        const products = [];
        const quantities = [];
        const skus = [];
        const unitPrices = [];
        const subTotals = [];
        const uoms = [];

        item.items.forEach(function(el, index) {
          products.push(<span key={index}>{el.ProductName}<br/></span>);
          uoms.push(<span key={index}>{el.UOM}<br/></span>);
          quantities.push(<span key={index}>{el.QTY}<br/></span>);
          skus.push(<span key={index}>{el.SKUNumber}<br/></span>);
          unitPrices.push(<span key={index}>{formatCurrency(el.UnitPrice)}<br/></span>);
          subTotals.push(<span key={index}>{formatCurrency(el.SubTotal)}<br/></span>);
        }, this);

        return (
          <tr key={item.InvoiceNumber} className={index % 2 !== 0 ? 'gray-row' : ''}>
            <td>{item.InvoiceNumber}</td>
            <td>{moment(item.InvoiceDate).format(dateTimeFormats.numeralDate)}</td>
            <td className="number">{quantities}</td>
            <td>{products}</td>
            <td>{uoms}</td>
            <td>{skus}</td>
            <td className="number">{unitPrices}</td>
            <td className="number">{subTotals}</td>
          </tr>
        );
      });
    }

    return (
      <div className='container-fluid purchase-details'>
        <a className={this.state.data && this.state.data.length > 0 ? 'link-style' : 'link-grayedout'}
           onClick={this.exportReport}><FormattedMessage id="general.export" /> <i className="bl bl-right_arrow"/>
        </a>
        <div className="table-container">
          <table>
            <tbody>
              <tr>
                <th><FormattedMessage id="general.invoice" /></th>
                <th><FormattedMessage id="general.date" /></th>
                <th className='table-header-right-align'><FormattedMessage id="general.quantity.abbreviation" /></th>
                <th><FormattedMessage id="general.product" /></th>
                <th><FormattedMessage id="general.unit.size" /></th>
                <th><FormattedMessage id="general.code" /></th>
                <th className='table-header-right-align'><FormattedMessage id="general.each" /></th>
                <th className='table-header-right-align'><FormattedMessage id="general.subtotal" /></th>
              </tr>
              {listItems}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

const PurchaseDetails = connectToPOSPermissions(POS_PERMISSIONS.PURCHASE_HISTORY)(_PurchaseDetails);

export default injectIntl(PurchaseDetails);
